module.exports = __webpack_public_path__ + "static/media/IdProof2.ebb4ce0f.svg";